import { Component, Input, ViewEncapsulation, Output, AfterViewInit, OnInit } from '@angular/core';

import { EventEmitter } from 'events';
import notify from 'devextreme/ui/notify';

@Component({
  /**
   * Component Selector
   */
  selector: 'crem-button',
/**
 * Example Usage
 * @example
 * Basic Button
 *
 * <crem-button [type]="type" [content]="content" [color]="color" [disabled]="disabled"></crem-button>
 *
 * Check it out on {@link http://stackoverflow.com|StackOverflow]
 *
 */
  template:  `<dx-button [stylingMode]="type" [text]="content"  [type]="color"  [disabled]="disabled" [icon]="iconName"  (onClick)="clicked($event)"></dx-button>`,
  styleUrls: ['./button.component.scss']
})
export class ButtonComponent implements OnInit{

  @Input() public content: string;
  @Input() public disabled: boolean;
  @Input() public color: string;
  @Input() public type: string;
  @Input() public iconName: string;

  // @Input() public icon: string ;

  @Output() click = new EventEmitter();
 clicked = (e) => {};

  // iconString: (i) => void;
  capitalize = text =>{
    text = this.content;
    return this.content.charAt(0).toUpperCase() + this.content.slice(1);
  }
    constructor() {
     this.clicked = (e) => {
      const button = e.component.option('text');
      this.click.emit('clicked');
      return notify("The " + this.capitalize(button) + " button was clicked");
  };
}
  ngOnInit(){
   }


}
